import {Box, Typography, useTheme} from "@mui/material";

// Color según el entorno: producción -> azul, test -> naranja, dev -> verde
const ENV_COLOR_KEYS = {
  produccion: "blue",
  test: "orange",
  pruebas: "orange",
  dev: "green",
  desarrollo: "green",
  local: "pink"
};

const EnvironmentBadge = ({environment = "No especificado"}) => {
  const theme = useTheme();
  const {colors} = theme.palette;
  const colorKey = ENV_COLOR_KEYS[environment.trim().toLowerCase()] || "blue";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.5,
        py: 0.5,
        borderRadius: 100,
        backgroundColor: colors[`${colorKey}BG`]
      }}
    >
      <Box sx={{width: 8, height: 8, borderRadius: "50%", backgroundColor: colors[colorKey], flexShrink: 0}} />
      <Typography variant="subtitle1" fontWeight="bold" sx={{color: colors[colorKey]}}>
        {environment.charAt(0).toUpperCase() + environment.slice(1)}
      </Typography>
    </Box>
  );
};

export default EnvironmentBadge;
